var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { log } from "../../utils";
export const namespaces = {
    html: "http://www.w3.org/1999/xhtml",
    svg: "http://www.w3.org/2000/svg",
    mathml: "http://www.w3.org/1998/Math/MathML",
    xul: "http://www.mozilla.org/keymaster/gatekeeper/there.is.only.xul",
    xbl: "http://www.mozilla.org/xbl",
};
export const lookupNamespaces = {
    "http://www.w3.org/1999/xhtml": "html",
    "http://www.w3.org/2000/svg": "svg",
    "http://www.w3.org/1998/Math/MathML": "mathml",
    "http://www.mozilla.org/keymaster/gatekeeper/there.is.only.xul": "xul",
    "http://www.mozilla.org/xbl": "xbl",
};
/** capture an instance of a dom tree */
export class Serializer {
    constructor(page) {
        this.page = page;
        this.svgContainer = null;
        this.svgs = {};
    }
    cleanup() {
        var _a;
        (_a = this.svgContainer) === null || _a === void 0 ? void 0 : _a.remove();
    }
    stylesheet(sheet) {
        return sheet
            ? Array.from(sheet.cssRules, (rule) => rule.cssText).join("\n")
            : "";
    }
    text(node) {
        if (node.parentNode.nodeName === "STYLE" ||
            node.parentNode.nodeName === "SCRIPT") {
            return "";
        }
        else {
            return node.nodeValue;
        }
    }
    node(node, props) {
        if (node.nodeType === node.ELEMENT_NODE) {
            return this.element(node, props);
        }
        else {
            return {
                id: (props.id = this.page.idp.add(node)),
                name: node.nodeName,
                text: props.text,
            };
        }
    }
    element(node, props) {
        var _a, _b, _c, _d, _e, _f, _g;
        const info = {
            id: (props.id = this.page.idp.add(node)),
            name: node.nodeName,
            attrs: props.attributes,
        };
        const ns = lookupNamespaces[node.namespaceURI];
        if (ns !== "html") {
            info.ns = ns;
        }
        try {
            switch (node.nodeName) {
                case "SCRIPT":
                    info.attrs = undefined;
                    break;
                case "STYLE":
                    info.sheet = {
                        rules: this.stylesheet(node.sheet),
                    };
                    break;
                case "LINK": {
                    let isSheet = false;
                    try {
                        isSheet = !!((_a = node.sheet) === null || _a === void 0 ? void 0 : _a.cssRules);
                    }
                    catch (_h) { }
                    if (isSheet) {
                        info.name = "STYLE";
                        info.sheet = {
                            href: node.href,
                            rules: this.stylesheet(node.sheet),
                        };
                        delete info.attrs.href;
                    }
                    else if (node.as
                        ? node.as === "script"
                        : (_b = node.href) === null || _b === void 0 ? void 0 : _b.endsWith(".js")) {
                        delete info.attrs;
                        info.name = "#comment";
                    }
                    break;
                }
                case "IMG":
                    if (this.page.isMobile) {
                        info.size = {
                            width: node.width,
                            height: node.height,
                        };
                    }
                    break;
                case "IFRAME": {
                    if (((_c = node.contentDocument) === null || _c === void 0 ? void 0 : _c.contentType) ===
                        "application/pdf") {
                        info.attrs["data-ispdf"] = "true";
                        break;
                    }
                    else if ((_e = (_d = info.attrs) === null || _d === void 0 ? void 0 : _d.src) === null || _e === void 0 ? void 0 : _e.includes(".pdf")) {
                        const url = new URL(info.attrs.src, location.href);
                        if (url.pathname.toLowerCase().endsWith(".pdf")) {
                            info.attrs["data-ispdf"] = "true";
                            break;
                        }
                    }
                    // no need for url if we have access
                    if (node.contentDocument) {
                        delete info.attrs.src;
                        delete info.attrs.sandbox;
                        if (info.attrs.srcdoc) {
                            info.attrs.srcdoc = "";
                        }
                    }
                    break;
                }
                // svg embed, they are lowercase
                case "use": {
                    const href = (_f = (node.getAttribute("href") ||
                        node.getAttribute("xlink:href"))) === null || _f === void 0 ? void 0 : _f.split("#");
                    if (href.length === 2) {
                        // init or dom reset
                        if (!this.svgContainer) {
                            this.svgContainer = this.page.getDocument().createElement("div");
                            this.svgContainer.setAttribute("style", "display:none");
                            this.svgContainer.setAttribute("data-use", "auvious-svg-container");
                            for (const href in this.svgs) {
                                this.svgContainer.appendChild(this.svgs[href]);
                            }
                        }
                        if (!this.svgContainer.isConnected) {
                            setTimeout(() => this.page.getDocument().body.appendChild(this.svgContainer), 0);
                        }
                        if (href[0] && !(href[0] in this.svgs)) {
                            this.svgs[href[0]] = null;
                            this.page
                                .getWindow()
                                .fetch(href[0])
                                .then((response) => __awaiter(this, void 0, void 0, function* () {
                                const svgText = yield response.text();
                                const parser = new DOMParser();
                                const svgDoc = parser.parseFromString(svgText, "image/svg+xml");
                                this.svgs[href[0]] = svgDoc.documentElement;
                                this.svgContainer.appendChild(this.svgs[href[0]]);
                            }))
                                .catch((ex) => {
                                console.warn(`SVG resource at ${href[0]} could not be fetched and will not be rendered remotely: `, ex === null || ex === void 0 ? void 0 : ex.message);
                            });
                        }
                        (_g = info.attrs) !== null && _g !== void 0 ? _g : (info.attrs = {});
                        info.attrs.href = info.attrs["xlink:href"] = "#" + href[1];
                    }
                }
            }
        }
        catch (error) {
            log(error, node);
        }
        return info;
    }
    attributes(elm) {
        const attrs = {};
        for (let i = 0; i < elm.attributes.length; i++) {
            const attr = elm.attributes[i];
            attrs[attr.name] =
                attr.name.startsWith("on") && elm[attr.name] instanceof Function
                    ? undefined
                    : attr.value;
        }
        return attrs;
    }
    attribute(elm, name) {
        return name.startsWith("on") && elm[name] instanceof Function
            ? undefined
            : elm.getAttribute(name);
    }
}
